import { useCartQuery } from "@graphcommerce/magento-cart";
import IconCart3 from "../icons/IconCart3";
import IconHeartFill from "../icons/IconHeartFill";
import IconStatsChartSharp from "../icons/IconStatsChartSharp";
import { CartItemSummaryDocument } from "@graphcommerce/magento-cart/components/CartItemSummary/GetCartItemSummary.gql";
import { useCustomerQuery } from "@graphcommerce/magento-customer";
import { GetWishlistProductsDocument } from "@graphcommerce/magento-wishlist";
import { useCompareSummary } from "@graphcommerce/magento-compare";
import { useWishlist } from "../../context/wishlistContext";

export default function CheckIcons({ uid, id, sku }: { uid: string; id: string; sku: string }) {
  const cartData = useCartQuery(CartItemSummaryDocument);
  const { items: wishlist } = useWishlist()

  const compareList = useCompareSummary();

  const inCart = cartData.data?.cart?.items?.some(i => i?.product.uid === uid);
  const inWishlist = wishlist?.some(i => i?.products?.some(i2 => i2?.id === id || i2?.sku === sku));
  const inCompareList = compareList.data?.compareList?.items?.some(i => i?.uid === id)
  return (
    <>
      {inCart ? <span className="block text-light-200/60 mr-1 mt-2">
        <IconCart3 width={18} height={18} />
      </span> : null}
      {inWishlist ? <span className="block text-light-200/60 mr-1 mt-1">
        <IconHeartFill width={18} height={18} />
      </span> : null}
      {inCompareList ? <span className="block text-light-200/60 mr-1 mt-1">
        <IconStatsChartSharp width={18} height={18} />
      </span> : null}
    </>
  )
}